exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".clients-mobile-slider>div{width:50%;height:50%;display:inline-block;text-align:center;padding:0 10px}.clients-mobile-slider>div>img.client-image{position:static!important;display:inline-block!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/features/PageCompany/Components/Clients/SliderResponsive.scss
// module id = 964
// module chunks = 0